import { render, staticRenderFns } from "./dendropdown.vue?vue&type=template&id=0927b8c2&"
import script from "./dendropdown.vue?vue&type=script&lang=js&"
export * from "./dendropdown.vue?vue&type=script&lang=js&"
import style0 from "./dendropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports